<template>
  <v-card>
    <v-card-title class="justify-center">
      <span class="text-h5">{{ $t('Message') }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          {{ getTranslation(messageProps) }}
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="cancelProps"
        class="close-button"
        text
        v-on:click="decline()"
      >
        {{ getTranslation(cancelProps) }}
      </v-btn>
      <v-btn
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="approve()"
      >
        {{ getTranslation(validationProps) }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'MessageAlert',
    props: {
      messageProps: {
        type: String
      },
      cancelProps: {
        type: String
      },
      validationProps: {
        type: String
      },
    },
    mounted: function(){
      console.log('test mount');
    },
    methods: {
      getTranslation(val) {
          return this.$t(val);
      },
      decline: function(){
        console.log('decline');
        this.$emit('answerModal', false);
        this.$emit('update:dialog', false);
      },
      approve: function(){
        console.log('approve');
        this.$emit('answerModal', true);
        this.$emit('update:dialog', false)
      }
    }
  }
</script>